import { Button } from '@cian/ui-kit';

import * as React from 'react';

export interface IConfirmButton {
  isMobile?: boolean;
  disabled?: boolean;
  onClick?(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}

export const ConfirmButton: React.FC<IConfirmButton> = ({ isMobile, disabled, onClick }) => {
  const buttonSize = isMobile ? 'M' : 'XS';

  return (
    <Button
      type="submit"
      disabled={disabled}
      size={buttonSize}
      theme="fill_primary"
      onClick={onClick}
      fullWidth={isMobile}
    >
      Сохранить
    </Button>
  );
};

ConfirmButton.displayName = 'ConfirmButton';
